import { LoaderCircle } from "lucide-react"

export function ReportConfigurationDonePanel() {
    return (
        <div className="flex items-center justify-center h-full gap-1">
            <LoaderCircle className="animate-spin motion-safe:animate-[spin_2s_linear_infinite]" />
            <span>You will be redirected in a few seconds.</span>
        </div>
    )
}
